import { UpdateAddressCollectionSchema } from "@redotech/redo-model/address-collection";
import * as z from "zod";

export const updateAddress = {
  name: "updateAddress" as const,
  input: z.object({ id: z.string(), updates: UpdateAddressCollectionSchema }),
  output: z.object({ success: z.boolean() }),
};
